import type {IRegisterExtended} from "../types/IRegisterExtended";

export const registerFormExtendedDefaultValues: IRegisterExtended = {
    name: "",
    email: "",
    password: "",
    phone: {code: 48, number: ""},
    marketing_email: false,
    marketing_sms: false
};
import type {IRegisterExtended} from "../types/IRegisterExtended";

export const registerFormExtendedDefaultValues: IRegisterExtended = {
    name: "",
    email: "",
    password: "",
    phone: {code: 48, number: ""},
    marketing_email: false,
    marketing_sms: false
};
